// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompanySectionOne {
  width: 100%;
  min-height: 400px;
  background: #ea6927;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  position: relative;
  font-size: 18px;
  margin-top: 60px;
  padding: 100px 175px;
  gap: 3%;
}
.CompanySectionOne .CompanySectionOne-left {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  margin-right: 10px;
}
.CompanySectionOne .CompanySectionOne-left .CompanySectionOne-left-heading {
  font-size: 38px;
  font-weight: bold;
  margin-bottom: 2rem;
}
.CompanySectionOne .CompanySectionOne-left .CompanySectionOne-left-text {
  font-size: 18px;
  line-height: 33px;
}
.CompanySectionOne .CompanySectionOne-right {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  margin-left: 10px;
}
.CompanySectionOne .CompanySectionOne-right img {
  width: 100%;
}
.CompanySectionOne .CompanySectionOne-count-div {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 350px);
  position: absolute;
  bottom: -100px;
  z-index: 5;
  padding: 20px;
  background-color: #ffffff;
  color: #000000;
}
.CompanySectionOne .CompanySectionOne-count-div .CompanySectionOne-count-div-inner {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.CompanySectionOne .CompanySectionOne-count-div .CompanySectionOne-count-div-inner h3 {
  font-size: 71px;
  margin: 0;
  padding: 0;
}
.CompanySectionOne .CompanySectionOne-count-div .CompanySectionOne-count-div-inner p {
  font-size: 34px;
  margin: 0;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Company/SectionOne/SectionOne.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACG,oBAAA;EACH,OAAA;AACD;AACC;EACC,aAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;AACF;AACE;EACC,eAAA;EACA,iBAAA;EACA,mBAAA;AACH;AAEE;EACC,eAAA;EACA,iBAAA;AAAH;AAIC;EACC,aAAA;EACA,SAAA;EACA,sBAAA;EACA,iBAAA;AAFF;AAIE;EACC,WAAA;AAFH;AAMC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;AAJF;AAOE;EACC,aAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AALH;AAOG;EACC,eAAA;EACA,SAAA;EACA,UAAA;AALJ;AAQG;EACC,eAAA;EACA,SAAA;EACA,UAAA;AANJ","sourcesContent":[".CompanySectionOne {\n\twidth: 100%;\n\tmin-height: 400px;\n\tbackground: #ea6927;\n\tcolor: #ffffff;\n\tdisplay: flex;\n\tflex-direction: row;\n\tposition: relative;\n\tfont-size: 18px;\n\tmargin-top: 60px;\n    padding: 100px 175px;\n\tgap: 3%;\n\n\t.CompanySectionOne-left {\n\t\tdisplay: flex;\n\t\tflex: 1;\n\t\tflex-direction: column;\n\t\tmargin-right: 10px;\n\n\t\t.CompanySectionOne-left-heading {\n\t\t\tfont-size: 38px;\n\t\t\tfont-weight: bold;\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\n\t\t.CompanySectionOne-left-text {\n\t\t\tfont-size: 18px;\n\t\t\tline-height: 33px;\n\t\t}\n\t}\n\n\t.CompanySectionOne-right {\n\t\tdisplay: flex;\n\t\tflex: 1;\n\t\tflex-direction: column;\n\t\tmargin-left: 10px;\n\n\t\timg {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t.CompanySectionOne-count-div {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\twidth: calc(100% - 350px);\n\t\tposition: absolute;\n\t\tbottom: -100px;\n\t\tz-index: 5;\n\t\tpadding: 20px;\n\t\tbackground-color: #ffffff;\n\t\tcolor: #000000;\n\t\t// box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n\n\t\t.CompanySectionOne-count-div-inner {\n\t\t\tdisplay: flex;\n\t\t\tflex: 1;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\n\t\t\th3 {\n\t\t\t\tfont-size: 71px;\n\t\t\t\tmargin: 0;\n\t\t\t\tpadding: 0;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tfont-size: 34px;\n\t\t\t\tmargin: 0;\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
